<div id="canvasContainer">
  <canvas id="fabricCanvas"></canvas>
</div>


// WEBPACK FOOTER //
// ./src/app/damage-control/micro-canvas/micro-canvas.component.html